import React, { Component } from 'react'; // eslint-disable-line no-unused-vars
import { Menu, Dropdown } from 'antd';
import { Link } from 'react-router-dom';
import logo from '../../images/close-reading-logo.svg';

function CourseMenu(props){

  function renderLogin(){
    if(!props.course.user){
      return (
        <Menu.Item>
          <a href="/auth/google">Login</a>
        </Menu.Item>
      )
    } else {
      return (
        <Menu.Item >
          <div onClick={props.logOut}>Logout</div>
        </Menu.Item>
      )
    }
  }

const menu = (
  <Menu style = {{minWidth: '125px'}} theme="dark">
    {renderLogin()}
    <Menu.Item>
      <Link to="/catalog/courses">Catalog</Link>
    </Menu.Item>
  </Menu>
);

  return (
    <Dropdown id="CourseMenu" placement="bottomRight" overlay={menu}>
      <img id="coursemenu-logo" alt="menu" src={logo} style={{height: '37px'}}/>
    </Dropdown>
  )
}

export default CourseMenu;



// WEBPACK FOOTER //
// ./src/components/Course/CourseMenu.js